import React from "react";

import type { SeriesColumnOptions } from "highcharts";
import _ from "lodash";

import { ColumnChartGraph } from "@similarweb/pro-logic-components";

import { NoDataWrapperComp } from "app/pages/website-analysis/traffic-sources/mmx/components/ChannelsOverviewBarChart/ChannelsOverviewBarChartConfig";

import { ChannelsOverviewBarChartWrapper } from "./StyledComponents";

type ChartSeries = SeriesColumnOptions & {
    id?: string;
    name: string;
    color?: string;
    visible?: boolean;
};

interface IChannelsOverviewBarChart {
    data: any;
    config: any;
    dataAutomation: string;
    stackColumns?: boolean;
}

const ChannelsOverviewBarChartInner: React.FC<IChannelsOverviewBarChart> = ({
    data,
    config,
    dataAutomation,
    stackColumns,
}) => {
    const isEmpty = !data || _.isEmpty(data) || !config;

    return (
        <ChannelsOverviewBarChartWrapper data-automation={dataAutomation}>
            {isEmpty ? (
                <NoDataWrapperComp size="small" />
            ) : (
                <ColumnChartGraph<ChartSeries>
                    data={data as ChartSeries[]}
                    graphConfig={config}
                    stackColumns={stackColumns}
                    shouldPresentLegend={false}
                />
            )}
        </ChannelsOverviewBarChartWrapper>
    );
};

const propsAreEqual = (prevProps: IChannelsOverviewBarChart, nextProps: IChannelsOverviewBarChart) => {
    return (
        prevProps.data === nextProps.data &&
        prevProps.config === nextProps.config &&
        prevProps.stackColumns === nextProps.stackColumns
    );
};

export const ChannelsOverviewBarChart = React.memo(ChannelsOverviewBarChartInner, propsAreEqual);
